import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, GuideReviewsResponse } from '@/types';

export const guideReviewsApi = {
  async listMine(params?: { page?: number; limit?: number }) {
    const response = await apiClient.get<GuideReviewsResponse & { success: boolean }>(
      '/guide/reviews',
      { params }
    );
    return response.data;
  },
};

export const guideReviewsKeys = {
  all: ['guide-reviews'] as const,
  mine: (params?: { page?: number; limit?: number }) =>
    [...guideReviewsKeys.all, 'mine', params] as const,
};
